'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.weekly_active_report', {
        template: '<weekly-active-report></weekly-active-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/active_report/weekly/weekly_active_report.routes.js